import React, { useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { convertToDates } from "../../../utils/convertions";
import { Icon } from "../../../components/Component";
import {
  Button,
  Card as BootstrapCard,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Avatar,
  Card,
  Checkbox,
  Empty,
  Input,
  message,
  Modal,
  Popconfirm,
  Row,
  Skeleton,
} from "antd";
import {
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import SearchInput from "../../form-components/SearchComponent";
import { projectGroupApis } from "../../../api/ProjectGroup";
import FormInput from "../../form-components/InputComponent";
import { useDispatch, useSelector } from "react-redux";
import { updateMenuData } from "../../../store/slices/misc/menuData";
import TopMenu from "../../../route/topMenu";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

function GroupOfProjectsListView() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data: currentUser } = useSelector((state: any) => state.currentUser);
  // const { data: SideNavCollapse } = useSelector(
  //   (state: any) => state.SideNavCollapseStatus
  // );
  const methods = useForm({
    mode: "onChange",
  });

  // Scroll to top when component mounts or when navigating to this page
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const {
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = methods;
  const [customDateRange, setCustomDateRange] = useState<any>();
  const [dataSource, setDataSource] = useState<any>([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    defaultCurrent: 1,
    defaultPageSize: 10,
    showSizeChanger: true,
    pageSizeOptions: ["10", "20", "30", "40", "50"],

    total: 0,
  });
  const [loading, setLoading] = useState(false);
  const [screenSize, setScreenSize] = useState(0);
  const [searchQuery, setsearchQuery] = useState(null);
  const [selectFilter1, setselectFilter1] = useState(null);
  const [selectFilter2, setselectFilter2] = useState(null);
  const [selectFilter3, setselectFilter3] = useState(null);
  const [dateRange, setdateRange] = useState("Quarter to Date");
  const [filterCount, setFilterCount] = useState(1);
  const [cardViewCurrentPage, setCardViewCurrentPage] = useState(0);
  const [endOfList, setEndOfList] = useState(false);
  const lastCardRef = useRef<HTMLDivElement | null>(null);

  const [hoveredCardId, setHoveredCardId] = useState<any | null>(null);
  const [editingGroupId, setEditingGroupId] = useState<any | null>(null);
  const [editedName, setEditedName] = useState<string>("");
  const [isConfirmVisible, setConfirmVisible] = useState(false);
  const [confirmChecked, setConfirmChecked] = useState(false);
  const [selectedGroupId, setSelectedGroupId] = useState<any | null>(null);
  const [cardClikedId, setCardClikedId] = useState<any | null>(null);
  const showDeleteConfirm = (groupId: any) => {
    setSelectedGroupId(groupId);
    setConfirmVisible(true);
  };

  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (!lastCardRef.current || endOfList) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !loading) {
          setCardViewCurrentPage((prev) => prev + 1);
        }
      },
      { threshold: 1 }
    );

    observer.observe(lastCardRef.current);
    return () => observer.disconnect();
  }, [dataSource, loading]);

  const loadMoreData = (paginationId: any) => {
    try {
      if (paginationId === undefined || (paginationId !== null && endOfList)) {
        console.log("paginationId is ", paginationId);
        return; // return if paginationId is undefined
      }
      fetchData(
        {
          sortOrder: "DESC",
          pageSize: 8,
          direction: paginationId ? "F" : "P",
          pageDiff: 0,
          paginationId: paginationId,
          searchQuery,
          selectFilter1,
          selectFilter2,
          selectFilter3,
          dateRange,
          customDateRange,
        },
        !!paginationId // append if paginationId is not null
      );
    } catch (error) {
      console.error("Error loading more data:", error);
    }
  };

  useEffect(() => {
    loadMoreData(dataSource?.[dataSource?.length - 1]?.paginationId);
  }, [cardViewCurrentPage]);

  const refreshListView = () => {
    try {
      setEndOfList(false);
      setDataSource([]);
      loadMoreData(null);
    } catch (error) {}
  };

  useEffect(() => {
    dispatch(updateMenuData(TopMenu?.activeProjects));
    refreshListView();
  }, []);

  const viewChange = () => {
    setScreenSize(window.innerWidth);
  };

  useEffect(() => {
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
    };
  }, []);

  const fetchData = async (params: any, append = false) => {
    console.log("params", params);
    setLoading(true);
    try {
      const {
        current,
        sortOrder,
        pageSize,
        direction,
        pageDiff,
        paginationId,
        searchQuery,
        selectFilter1,
        selectFilter2,
        selectFilter3,
        dateRange,
        customDateRange,
      } = params;
      if (
        (dateRange == "Custom Date" && customDateRange == undefined) ||
        dateRange == undefined
      )
        return;
      const { from, to }: any =
        dateRange !== undefined && convertToDates(dateRange, customDateRange);
      const apiResponse = await projectGroupApis.getProjectGroupList({
        sortOrder,
        pageSize,
        direction,
        pageDiff,
        paginationId,
        searchQuery,
      });

      const { data, status } = apiResponse;
      if (status) {
        const { list, count } = data || {};
        if (list?.length < pageSize || !list) {
          setEndOfList(true);
        }
        setPagination((prev) => ({
          ...prev,
          total: Number(count),
        }));
        console.log("setDataSource", list);
        if (list?.length > 0)
          setDataSource((prev: any) => (append ? [...prev, ...list] : list));
        // setTimeout(() => {
        //   setDataSource((prev: any) => (append ? [...prev, ...list] : list));
        // }, listViewType == "card" ? 500:0);
      }
    } catch (error) {
      console.error("Error loading data:", error);
    } finally {
      setLoading(false);
    }
  };

  const getColorFromName = (name: string) => {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const color = `hsl(${hash % 160}, 20%, 50%)`;
    // const color = `hsl(${hash % 360}, 70%, 50%)`;
    return color;
  };

  const handleCreateGroup = async (data: any) => {
    console.log(data);
    try {
      const response = await projectGroupApis.createProjectGroup({
        projectGroupName: data.groupName,
      });
      const { status } = response;
      if (status) {
        message.success("Group created successfully");
        setModalOpen(false);
        reset();
        setEndOfList(false);
        refreshListView();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const content = (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(handleCreateGroup)}>
        <div style={{ width: 400 }}>
          {" "}
          {/* You can adjust this */}
          <FormInput
            label="Project Group"
            name="groupName"
            required={true}
            type="text"
          />
          <div
            className="mt-4"
            style={{ display: "flex", justifyContent: "flex-start", gap: 8 }}
          >
            <Button color="primary" htmlType="submit">
              Create Group
            </Button>
            <Button onClick={() => setModalOpen(false)}>Cancel</Button>
          </div>
        </div>
      </form>
    </FormProvider>
  );

  const onEditGroupName = async (groupId: any, newName: any) => {
    console.log("Group ID:", groupId, "New Name:", newName);
    // API call or state update
    try {
      const apiResponse = await projectGroupApis.updateProjectGroup({
        projectGroupId: groupId,
        projectGroupName: newName,
      });
      const { status } = apiResponse;
      if (status) {
        message.success("Projecct Group name updated");
        setEndOfList(false);
        refreshListView();
        setEditingGroupId(null);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDelete = async () => {
    if (confirmChecked && selectedGroupId) {
      try {
        const apiResponse = await projectGroupApis.deleteProjectGroup(
          selectedGroupId
        );
        const { status } = apiResponse;
        if (status) {
          setEndOfList(false);
          message.success("Projecct Group Deleted");
          setEditingGroupId(null);
          setSelectedGroupId(null);
          setConfirmVisible(false);
          setConfirmChecked(false);
          setOpenedGroups(null);
          refreshListView();
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const [openedGroups, setOpenedGroups] = useState<string | null>(null);

  const handleGroupClick = (groupId: string) => {
    setOpenedGroups(groupId);
  };

  const handleCloseGroup = (groupId: string) => {
    if (openedGroups === groupId) {
      setOpenedGroups(null);
      setCardClikedId(""); // Assuming this is needed for some UI logic
    }
  };

  return (
    <>
      <Head title={"Group of Projects"} />
      <Content>
        <BootstrapCard className="card-bordered">
          <div className="card-aside-wrap">
            <div
              className="card-inner card-inner-lg"
              style={{ minHeight: "87vh" }}
            >
              {openedGroups === null && (
                <FormProvider {...methods}>
                  <form>
                    <div
                      className="nk-ibx-head p-0 m-0 mt-1 w-100 d-flex justify-content-between align-items-center"
                      style={{ minHeight: "40px", border: "0px" }}
                    >
                      <div className="nk-ibx-head-actions w-45 ms-1">
                        <ul className="nk-ibx-head-tools g-1 m-0 p-0 w-100 ">
                          <div className={`w-100 m-0 `}>
                            <SearchInput
                              name="search"
                              placeholder="Search..."
                              width="100%"
                              prefixIcon={<SearchOutlined />}
                              onDebouncedSearch={async (value: any) => {
                                setsearchQuery(value);
                                setPagination({
                                  ...pagination,
                                  current: 1,
                                });
                              }}
                              debounceDelay={300} // Adjust delay as needed
                            />
                          </div>
                        </ul>
                      </div>
                      <ul className="nk-ibx-head-tools g-1 m-0 p-0 ">
                        <li className="pt-0 pb-0">
                          <Popconfirm
                            placement="bottomLeft"
                            title={content}
                            open={modalOpen}
                            onOpenChange={(val) => setModalOpen(val)}
                            icon={null}
                            showCancel={false}
                            okButtonProps={{ style: { display: "none" } }}
                          >
                            <Button
                              className="toggle"
                              color="primary"
                              size="sm"
                              onClick={() => {
                                setModalOpen(true);
                                // navigate("/pms/project-creation");
                              }}
                            >
                              <Icon name={"plus"} />
                              <span>Add Groups</span>
                            </Button>
                          </Popconfirm>
                          {/* <Button
               className="toggle"
               color="primary"
               size="sm"
               onClick={() => {
                 setModalOpen(true);
                 // navigate("/pms/project-creation");
               }}
             >
               <Icon name={"plus"} />
               <span>Add Groups</span>
             </Button> */}
                        </li>
                        <li>
                          <UncontrolledDropdown>
                            <DropdownToggle
                              tag="a"
                              className="dropdown-toggle btn btn-icon btn-trigger"
                              onClick={(ev) => {
                                refreshListView();
                              }}
                            >
                              <Icon name="redo"></Icon>
                            </DropdownToggle>
                          </UncontrolledDropdown>
                        </li>
                      </ul>
                    </div>
                  </form>
                </FormProvider>
              )}

              <div
                style={{
                  display: "flex",
                  gap: 0,
                  flexWrap: "nowrap",
                  overflowX: "auto",
                }}
              >
                <div className="card-inner card-inner-lg p-0">
                  <div className="content clearfix">
                    <div style={{ padding: "20px" }}>
                      <Row className="g-gs">
                        <div
                          style={{ display: "flex", gap: 16, flexWrap: "wrap" }}
                        >
                          {dataSource?.map((group: any, index: number) => {
                            const isEditing =
                              editingGroupId === group.projectGroupId;
                            const isHovered =
                              hoveredCardId === group.projectGroupId;
                            return (
                              <Card
                                ref={
                                  index === dataSource?.length - 1
                                    ? lastCardRef
                                    : null
                                }
                                key={group.projectGroupId}
                                style={{
                                  width: 320,
                                  borderRadius: 10,
                                  backgroundColor:
                                    cardClikedId === group.projectGroupId
                                      ? "#277af714"
                                      : isHovered
                                      ? "#f8f9fa"
                                      : "#fff",
                                  border:
                                    cardClikedId === group.projectGroupId
                                      ? "1px solid #277af733"
                                      : isHovered
                                      ? "1px solid #277af7"
                                      : "1px solid #e0e0e0",
                                  boxShadow:
                                    cardClikedId === group.projectGroupId
                                      ? "0 10px 8px #00000014"
                                      : isHovered
                                      ? "0 4px 12px rgba(39, 122, 247, 0.15)"
                                      : "0 2px 8px rgba(0,0,0,0.1)",
                                  padding: 16,
                                  position: "relative",
                                  transition: "all 0.3s ease",
                                  transform: isHovered
                                    ? "translateY(-2px)"
                                    : "translateY(0)",
                                  cursor: "pointer",
                                }}
                                onMouseEnter={() =>
                                  setHoveredCardId(group.projectGroupId)
                                }
                                onMouseLeave={() => setHoveredCardId(null)}
                                bodyStyle={{
                                  display: "flex",
                                  alignItems: "center",
                                  padding: 0,
                                }}
                              >
                                {!isEditing && (
                                  <Avatar
                                    size={40}
                                    style={{
                                      backgroundColor: getColorFromName(
                                        group.projectGroupName
                                      ),
                                      fontWeight: "bold",
                                      fontSize: 18,
                                      marginRight: 16,
                                    }}
                                  >
                                    {group.projectGroupName
                                      .split(" ")
                                      .map((word: any) => word[0])
                                      .join("")
                                      .toUpperCase()
                                      .slice(0, 2)}
                                  </Avatar>
                                )}
                                <div style={{ flex: 1 }}>
                                  {isEditing ? (
                                    <>
                                      <Input
                                        name={editedName}
                                        defaultValue={editedName}
                                        onInput={(e: any) =>
                                          setEditedName(e.target.value)
                                        }
                                        // label={"Project Group"}
                                      />
                                      <div
                                        className="mt-3"
                                        style={{ display: "flex", gap: 8 }}
                                      >
                                        <Button
                                          size="small"
                                          color="primary"
                                          onClick={() => {
                                            // Save logic
                                            onEditGroupName(
                                              group.projectGroupId,
                                              editedName
                                            ); // implement this
                                            setEditingGroupId(null);
                                            setHoveredCardId(null);
                                          }}
                                        >
                                          Save
                                        </Button>
                                        <Button
                                          size="small"
                                          onClick={() => {
                                            setEditingGroupId(null);
                                            setHoveredCardId(null);
                                          }}
                                        >
                                          Cancel
                                        </Button>
                                      </div>
                                    </>
                                  ) : (
                                    <div
                                      onClick={() => {
                                        handleGroupClick(group.projectGroupId);
                                        setCardClikedId(group.projectGroupId);
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <div style={{ fontWeight: 500 }}>
                                        {group.projectGroupName}
                                      </div>
                                      <div style={{ color: "#888" }}>
                                        {group.projectsCount} projects
                                      </div>
                                    </div>
                                  )}
                                </div>
                                {isHovered && !isEditing && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: 12,
                                      right: 12,
                                      display: "flex",
                                      gap: 8,
                                    }}
                                  >
                                    <EditOutlined
                                      style={{
                                        color: "#ff4d4f",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        setEditingGroupId(group.projectGroupId);
                                        setEditedName(group.projectGroupName);
                                      }}
                                    />
                                    <DeleteOutlined
                                      style={{
                                        color: "#ff4d4f",
                                        cursor: "pointer",
                                      }}
                                      // onClick={() => onDeleteGroup(group.id)}
                                      onClick={() =>
                                        showDeleteConfirm(group.projectGroupId)
                                      }
                                    />
                                  </div>
                                )}
                              </Card>
                            );
                          })}
                        </div>

                        {loading &&
                          Array.from({ length: 8 })?.map((_, index) => (
                            <div key={index} className="col-3">
                              <Card>
                                <Skeleton active />
                              </Card>
                            </div>
                          ))}
                      </Row>
                    </div>
                  </div>
                </div>
                {openedGroups && (
                  <ExpandedGroupView
                    groupId={openedGroups}
                    dataSource={dataSource}
                    onClose={handleCloseGroup}
                    navigate={navigate}
                    currentUser={currentUser}
                  />
                )}
              </div>
            </div>
          </div>
        </BootstrapCard>
      </Content>

      <Modal
        title={<div>Delete Project Group?</div>}
        closable={false}
        open={isConfirmVisible}
        onCancel={() => {
          setConfirmVisible(false);
          setConfirmChecked(false);
        }}
        footer={[
          <Button
            key="delete"
            color="primary"
            danger
            disabled={!confirmChecked}
            onClick={handleDelete}
            style={{
              backgroundColor: "#ff4d4f",
              borderColor: "#ff4d4f",
              opacity: confirmChecked ? 1 : 0.6,
              marginRight: "3%",
            }}
          >
            Delete
          </Button>,
          <Button
            key="cancel"
            color="default"
            onClick={() => setConfirmVisible(false)}
          >
            Cancel
          </Button>,
        ]}
      >
        <p>The projects will be moved to Ungrouped Projects section.</p>
        <p>This cannot be undone.</p>
        <Checkbox
          checked={confirmChecked}
          onChange={(e) => setConfirmChecked(e.target.checked)}
        >
          I understand that once deleted, this group cannot be recovered.
        </Checkbox>
      </Modal>
    </>
  );
}

export default GroupOfProjectsListView;

const ExpandedGroupView = ({
  groupId,
  dataSource,
  onClose,
  navigate,
  currentUser,
}: {
  groupId: string;
  dataSource: any;
  onClose: (id: string) => void;
  navigate: any;
  currentUser: any;
}) => {
  const groupData = dataSource.find((g: any) => g.projectGroupId === groupId);
  return (
    <Card
      style={{
        width: "500%",
        minHeight: 500,
        borderRadius: 0,
        position: "relative",
        backgroundColor: "#f5f5f5",
      }}
      bodyStyle={{ borderRadius: 0 }}
    >
      <Button
        onClick={() => onClose(groupId)}
        color=""
        style={{ position: "absolute", top: 8, right: 8 }}
      >
        <CloseOutlined />
      </Button>
      <h5 className="title mt-2">{groupData?.projectGroupName} Projects</h5>
      <div>
        {groupData?.projects?.length !== 0 && (
          <div>
            <Row className="g-gs">
              <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                {groupData?.projects?.map((project: any) => {
                  return (
                    <Card
                      key={project.projectId}
                      style={{
                        width: 320,
                        borderRadius: 10,
                        padding: 16,
                        position: "relative",
                        transition: "all 0.3s ease",
                        backgroundColor: "#fff",
                        border: "1px solid #e0e0e0",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        cursor: "pointer",
                      }}
                      bodyStyle={{
                        display: "flex",
                        alignItems: "center",
                        padding: 0,
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#f8f9fa";
                        e.currentTarget.style.borderColor = "#277af7";
                        e.currentTarget.style.boxShadow =
                          "0 4px 12px rgba(39, 122, 247, 0.15)";
                        e.currentTarget.style.transform = "translateY(-2px)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "#fff";
                        e.currentTarget.style.borderColor = "#e0e0e0";
                        e.currentTarget.style.boxShadow =
                          "0 2px 8px rgba(0,0,0,0.1)";
                        e.currentTarget.style.transform = "translateY(0)";
                      }}
                    >
                      <Avatar
                        size={40}
                        style={{
                          // backgroundColor: getColorFromName(group.projectGroupName),
                          fontWeight: "bold",
                          fontSize: 18,
                          marginRight: 16,
                        }}
                      >
                        {project?.projectTitle
                          .split(" ")
                          .map((word: any) => word[0])
                          .join("")
                          .toUpperCase()
                          .slice(0, 2)}
                      </Avatar>
                      <div style={{ flex: 1 }}>
                        <div
                          onClick={() => {
                            let allowEdit = true;
                            if (project?.lock) {
                              if (project?.lockedBy != currentUser?.id)
                                allowEdit = false;
                            }
                            navigate(
                              project?.projectId
                                ? `/pms/project/view/${project.projectId}`
                                : "/pms/project/view",
                              {
                                state: {
                                  id: project?.projectId,
                                  derivedProjectStatus:
                                    project?.derivedProjectStatus,
                                  projectName: project?.projectTitle,
                                  extra: {
                                    screenName: "Active",
                                    lock: project?.lock,
                                    allowEdit,
                                    lockedOn: project?.updatedAt
                                      ? dayjs(project?.updatedAt).format(
                                          "DD-MMM-YYYY"
                                        )
                                      : dayjs(project?.createdAt).format(
                                          "DD-MMM-YYYY"
                                        ),
                                    currentUserId: currentUser?.id,
                                    lockedBy: project?.lockedBy,
                                    lockedByUserName:
                                      project?.lockedByUserName || "N/A",
                                    plannedStartDate: project?.plannedStartDate,
                                    plannedEndDate: project?.plannedEndDate,
                                    siteId: project?.siteId,
                                    siteName: project?.siteName,
                                  },
                                },
                              }
                            );
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <div style={{ fontWeight: 500 }}>
                            {project?.projectTitle}
                          </div>
                          {/* <div style={{ color: "#888" }}>
                            {project.projectDescription}
                          </div> */}
                        </div>
                      </div>
                    </Card>
                  );
                })}
              </div>
            </Row>
          </div>
        )}
        {groupData?.projects?.length === 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "350px",
            }}
          >
            <Empty
              style={{}}
              description="No project is associated with this group"
            />
          </div>
        )}
      </div>
    </Card>
  );
};
